<template lang="pug">
    section(id="memberpurchases")
        PurchasesList(context="member-purchases")
</template>

<script>
import PurchasesList from '@/components/PurchasesList.vue'
import { mapMutations } from 'vuex'

export default {
    name: 'MemberPurchases',
    components: {
        PurchasesList
    },
    methods: {
        ...mapMutations({
            resetPurchasesPaginated: 'ext_shop_purchase/resetPurchasesPaginated'
        })
    },
    beforeDestroy() {
        this.resetPurchasesPaginated()
    }
}
</script>

<style lang="sass">
#memberpurchases
    padding: 0px
</style>
